export default __webpack_public_path__ + "static/media/576.48e7dee0.png";